import React from 'react';
import PropTypes from 'prop-types';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import enUS from 'antd/locale/en_US';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const fontFamily = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const muiTheme = createTheme({
  palette: { mode: 'light', primary: { main: '#b54708' }, secondary: { main: '#344054' } },
  typography: { fontFamily, fontSize: 14 },
  shape: { borderRadius: 10 },
});
const theme = { token: {
  colorPrimary: '#b54708', colorText: '#202939', colorTextSecondary: '#596579',
  colorBorder: '#dfe4eb', colorBgLayout: '#f5f6f8', borderRadius: 10,
  controlHeight: 44, fontFamily,
} };

// Legacy display preferences never override the new presentation. Business
// storage and authentication remain untouched.
export function initializeModernTheme() {
  document.documentElement.setAttribute('data-ui', 'modern');
  document.documentElement.setAttribute('data-theme', 'light');
  document.documentElement.setAttribute('data-layout', 'default');
}

export default function ModernTheme({ children }) {
  const { i18n } = useTranslation();
  return <ConfigProvider theme={theme} locale={i18n.language.startsWith('fr') ? frFR : enUS}>
    <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
  </ConfigProvider>;
}
ModernTheme.propTypes = { children: PropTypes.node };
